import { Helmet } from 'react-helmet-async';
import { DOMAIN, COMPANY } from '../constants';

const DEFAULT_OG_IMAGE = 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1200&h=630&fit=crop&q=80';

const LOCAL_BUSINESS_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': ['LocalBusiness', 'HomeAndConstructionBusiness'],
  '@id': DOMAIN,
  'name': COMPANY,
  'url': DOMAIN,
  'telephone': '+4369917170002',
  'address': {
    '@type': 'PostalAddress',
    'streetAddress': 'Märzstraße 71/1-7',
    'addressLocality': 'Wien',
    'postalCode': '1150',
    'addressCountry': 'AT'
  },
  'geo': {
    '@type': 'GeoCoordinates',
    'latitude': 48.1965,
    'longitude': 16.3291,
  },
  'hasMap': 'https://maps.google.com/?q=M%C3%A4rzstra%C3%9Fe+71%2C+1150+Wien',
  'areaServed': ['Wien', 'Klosterneuburg', 'Mödling', 'Schwechat', 'Wiener Neustadt', 'Baden bei Wien'],
  'openingHoursSpecification': [{
    '@type': 'OpeningHoursSpecification',
    'dayOfWeek': ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'],
    'opens': '07:00',
    'closes': '20:00'
  }],
  'aggregateRating': {
    '@type': 'AggregateRating',
    'ratingValue': '4.9',
    'reviewCount': '200',
    'bestRating': '5',
    'worstRating': '1'
  },
  'priceRange': 'EUR 290 - EUR 2000',
};

export default function SEOHead({ title, description, keywords, canonical, ogImage, extraSchemas = [] }) {
  const schemas = [LOCAL_BUSINESS_SCHEMA, ...extraSchemas];
  const imageUrl = ogImage || DEFAULT_OG_IMAGE;
  const fullUrl = `${DOMAIN}${canonical}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={fullUrl} />
      <meta name="robots" content="index, follow" />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={`${COMPANY} – Wohnungsräumung in Wien`} />
      <meta property="og:site_name" content={COMPANY} />
      <meta property="og:locale" content="de_AT" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content={`${COMPANY} – Wohnungsräumung in Wien`} />

      <script type="application/ld+json">{JSON.stringify(schemas)}</script>
    </Helmet>
  );
}
